var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger-block",on:{"click":function($event){return _vm.changeVision()}}},[_c('img',{class:{visibleBurgerMenu: !_vm.get_sidebar_open_state},attrs:{"src":require("../assets/img/burger.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }